import { render, staticRenderFns } from "./Anexo.vue?vue&type=template&id=5f287268"
import script from "./Anexo.vue?vue&type=script&lang=js"
export * from "./Anexo.vue?vue&type=script&lang=js"
import style0 from "./Anexo.vue?vue&type=style&index=0&id=5f287268&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports